import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "loading" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass({ 'ui-loading': _ctx.loading })
              }, [
                (_ctx.loading)
                  ? _renderSlot(_ctx.$slots, "loading", { key: 0 }, () => [
                      _hoisted_1,
                      _createTextVNode(" " + _toDisplayString(_ctx.loadingMessage), 1)
                    ])
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.error)
            ? _renderSlot(_ctx.$slots, "error", { key: 1 }, () => [
                _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
              ])
            : _createCommentVNode("", true),
          (_ctx.ok)
            ? _renderSlot(_ctx.$slots, "ok", { key: 2 }, () => [
                _createTextVNode(_toDisplayString(_ctx.okMessage), 1)
              ])
            : _createCommentVNode("", true),
          (!_ctx.loading)
            ? _renderSlot(_ctx.$slots, "default", { key: 3 })
            : _createCommentVNode("", true)
        ])
      ]),
      _: 3
    })
  ]))
}